export default __webpack_public_path__ + "static/media/Head_2_Ear_1_C1.1f42387a.svg";